import type {
  ToothBasisSeriesName,
  ToothBasisSeriesTile,
} from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import type { ToothBasisSeriesTileView, ToothBasisSeriesView } from '../config';

import { pixelsToPngUrl } from './pixelsToPngUrl';

const toTileViews = (
  tiles: ToothBasisSeriesTile[] = [],
): ToothBasisSeriesTileView[] =>
  tiles.map((tile) => ({
    offsetMm: tile.offsetMm,
    pngUrl: pixelsToPngUrl({
      height: tile.height,
      pixels: tile.pixels,
      width: tile.width,
    }),
  }));

export const makeToothBasisSeriesView = (
  series: Record<ToothBasisSeriesName, ToothBasisSeriesTile[]>,
): ToothBasisSeriesView => ({
  axial: toTileViews(series.axial),
  frontal: toTileViews(series.frontal),
  sagittal: toTileViews(series.sagittal),
});
